
<div class="flex flex-row justify-center pb-3 pr-2 relative items-center">
    <div class="flex flex-row items-center sm:mt-3">
        <h2 mat-dialog-title class="!pl-0 dialog-heading sm:pr-0 pr-5">Download The App To Register</h2>
    </div>
    <button mat-icon-button class="dialog-close-btn flex items-center justify-center"
        (click)="this._matDialogRef.close()">
        <mat-icon class="text-orange-color text-xl">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mt-16 pt-0 pl-3">
    <div class="text-center max-w-lg mx-auto"> 
        <p class="text-base text-[#000000DE] leading-6 mt-2 font-medium">
            To register with your affiliate link, please download the Phlenu Android or iOS app.
        </p>
        <p class="text-base text-[#000000DE] leading-6 mt-5 font-medium">Use the referral code below during registration.</p>

        <div class="md:mt-8 sm:mt-6 mt-4">
            <div class="bg-titanWhite mt-3 tracking-normal inline-block md:px-9 sm:px-7 px-6 md:py-7 sm:py-5 py-3 sm:text-3xl text-2xl rounded-xl text-blue-theme-color font-medium">{{this._data?.affData?.affiliateCode}}</div>
        </div> 

        <div class="sm:mt-8 mt-5 sm:mb-3 mb-2">
            <p class="text-[#000000DE] text-[18px] mb-5 leading-6 font-semibold text-center">Download Link</p>
            <div class="flex justify-center gap-4">
                <!-- IOS -->
                <div (click)="onIOS()" class="actionItem select-none actionFlex" matRipple>
                    <img draggable="false" src="assets/images/ui/ios_icon.png" class="sm:w-36 w-28" alt="">
                </div>
                <!-- android -->
                <div (click)="onAndroid()" class="actionItem select-none actionFlex" matRipple>
                    <img draggable="false" src="assets/images/ui/android_icon.png" class="sm:w-36 w-28" alt="">
                </div>
            </div>
        </div>

    </div>
</mat-dialog-content>